// Updated April 2026 - 18 divisions per current organizational structure.
export enum DepartmentEnum {
    archive = 'ארכיון',
    boardCouncil = 'מועצה',
    ceoOffice = 'לשכת מנכ"ל',
    digital = 'דיגיטל',
    engineering = 'הנדסה',
    freelancer = 'פרילנסרים',
    hr = 'משאבי אנוש',
    legal = 'משפטית',
    makan = 'מכאן',
    marketingPromo = 'שיווק ופרומו',
    mediaDept = 'מדיה',
    news = 'חדשות',
    operations = 'תפעול',
    radio = 'רדיו',
    reshetBet = 'רשת ב',
    security = 'אבטחה',
    television = 'טלוויזיה',
    translate = 'תרגום',
}

// Maps DepartmentEnum to English names received from Azure AD
export const departmentMap = new Map<DepartmentEnum, string>([
    [DepartmentEnum.archive, 'Archive Division'],
    [DepartmentEnum.boardCouncil, 'Board / Council Division'],
    [DepartmentEnum.ceoOffice, 'Headquarters - Office of the Director General'],
    [DepartmentEnum.digital, 'Digital Division'],
    [DepartmentEnum.engineering, 'Engineering Division'],
    [DepartmentEnum.freelancer, 'Freelancer'],
    [DepartmentEnum.hr, 'Human Resources Division'],
    [DepartmentEnum.legal, 'Legal Division'],
    [DepartmentEnum.makan, 'The Makan Division'],
    [DepartmentEnum.marketingPromo, 'Marketing & Promo Division'],
    [DepartmentEnum.mediaDept, 'Media Department'],
    [DepartmentEnum.news, 'News Division'],
    [DepartmentEnum.operations, 'Operations Division'],
    [DepartmentEnum.radio, 'Radio Division'],
    [DepartmentEnum.reshetBet, 'Reshet Bet Division'],
    [DepartmentEnum.security, 'Security Division'],
    [DepartmentEnum.television, 'Television Division'],
    [DepartmentEnum.translate, 'Translate Department'],
]);

// Returns Hebrew department name from English department name (from Azure AD)
export const getHebrewDepartmentName = (department: string): string => {
    const entry = Array.from(departmentMap.entries()).find(([, eng]) => eng === department);
    return entry ? entry[0] : 'לא ידוע';
};
